import React from "react";
import "./CodeBlock.scss";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CopyToClipboard from "../../utils/copyToClipboard";
import { JsonViewer } from "@textea/json-viewer";

function CodeBlock({
  title,
  requestType,
  content,
  endpointName,
  codeBlockType = "request",
}) {
  const customTheme = {
    expandIcon: null, // Removing the expandable feature
    base0D: "#1A3673", // Customizing the background color to blue
    base0F: "#75EC75",
  };
  return (
    <>
      <div className="code-container">
        <h5>
          {title}
          {endpointName && ` - ${endpointName}`}
        </h5>
        {codeBlockType === "jsonType" && (
          <code class="request">
            <div className="middle">
              <JsonViewer
                sx={{
                  color: "#75EC75 !important",
                  backgroundColor: "#1A3673 !important",
                }}
                theme={customTheme}
                value={content}
                displayDataTypes={false}
                displaySize={false}
                editable={false}
                expandAll={true}
              />
            </div>
          </code>
        )}
        {codeBlockType === "request" && (
          <code class="request">
            <div className="middle">
              {Object.keys(content).map((key) => {
                return (
                  <div className="property" key={key}>
                    <p>{key}</p>
                    <p>
                      {content[key]?.parameters
                        ? content[key]?.path +
                          "?" +
                          content[key]?.parameters
                            .map((param) => param.name + "={value}")
                            .join("&")
                        : content[key]?.path
                        ? content[key]?.path
                        : content[key]}
                    </p>
                  </div>
                );
              })}
            </div>
          </code>
        )}
      </div>
    </>
  );
}

export default CodeBlock;
